<template>
<div>
<transportation/>

</div>
</template>

<script>
import transportation from "../../components/Transportations/transportation.vue";


export default {
  components: {
   transportation
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>